import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface RenterInviteDrawerState {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const useRenterInviteDrawerStore = create<RenterInviteDrawerState>()(
  devtools(
    (set) => ({
      isOpen: false,
      openDrawer: () => set({ isOpen: true }),
      closeDrawer: () => set({ isOpen: false }),
    }),
    { name: 'renter-invite-drawer-store' },
  ),
);

export default useRenterInviteDrawerStore;
